import firebase from 'firebase'
const firebaseConfig = {
  apiKey: "AIzaSyCxF02OncwuIQrXB9cEXf7zM2iaLgSqK28",
  authDomain: "dem-doc.firebaseapp.com",
  databaseURL: "https://dem-doc.firebaseio.com",
  projectId: "dem-doc",
  storageBucket: "dem-doc.appspot.com",
  messagingSenderId: "954275826275",
  appId: "1:954275826275:web:f857b2898c54d6d0d38656"
};
export default firebase.initializeApp(firebaseConfig);
